<template>
      <div class="buscador-modal" :class="(isOpen)?'open':''">
        <div class="buscador-modal__inner">
          <a style="cursor:pointer;" @click="$emit('close')" class="modal__cerrar"><span class="sr-only">Cerrar</span></a>
          <form class="formulario-buscar" @submit.prevent="submit">
            <div class="form-group">
              <input id="modal--buscar-input" v-model="form.buscar" type="text" class="form-control" placeholder="¿Qué estas buscado?" required="">
              <div class="ico"></div>
              <select class="form__select" required v-model="form.categoria">
                    <option value="" selected disabled>¿En qué categoría?</option>
                    <option value="tramites-servicios">Trámites y Servicios</option>
                    <option value="noticias">Noticias</option>
                    <option value="eventos">Eventos</option>
                    <option value="programas">Programas</option>
                    <option value="directorio-municipal">Directorio Municipal</option>
                    <option value="centros-dif">Centros DIF</option>
                    <option value="lugares-interes">Lugares de Interés</option>
                    <option value="dependencias">Dependencias Municipales</option>
                    <option value="titulares-dependencias">Titulares de las Dependencias</option>
                    <option value="comisiones">Comisiones</option>
                    <option value="marco-normativo">Marco Normativo</option>
                    <optgroup label="Mejora Regulatoria">
                        <option value=""></option>
                        <option value="mejora-programa">Programa Anual de Mejora Regulatoria</option>
                        <option value="mejora-analisis">Análisis de Impacto Regulatorio</option>
                        <option value="mejora-agenda">Agenda Regulatoria</option>
                        <option value="mejora-inspecciones">Listado de inspecciones y verificaciones</option>
                        <option value="mejora-padron">Padrón de Inspectores y Verificadores</option>
                        <option value="mejora-normativa">Normativa para la Mejora Regulatoria</option>
                    </optgroup>
                </select>
              <button type="submit" class="boton-negro boton-flecha">Buscar</button>
            </div>
          </form>
        </div>
      </div>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3';

export default {
    props:{
        isOpen: Boolean,
        function: Object,
    },
    computed(){
       const close = this.function;
    },
    components: { },
    methods:{
      closeBuscador : close,
    },
    setup(props, context) {
        const form = useForm({
            buscar: '',
            categoria: '',
        });

        function submit() {
            form.get('/buscador', {
                preserveScroll: false,
                onSuccess: function(){
                    context.emit('close')
                    form.reset()
                },
            });
        }

        return {
            form, submit
        }
    },
}
</script>
<style scoped>
.boton-negro {
    font-family: "Playfair Display", Georgia, serif;
    font-style: italic;
    font-weight: 500;
    border-radius: 7px;
    color: #fff;
    display: inline-block;
    font-size: 18px;
    line-height: 24px;
    padding: 12px 20px 15px;
    transition: 0.5s;
    text-align: center;
    transition: 0.5s;
    background-color: #2d2a26;
    border: 2px solid #2d2a26;
}
.boton-negro:hover, .boton-negro:focus {
    background-color: rgba(51, 158, 136, 0);
    color: #000000;
}
.boton-negro::after {
    background-image: url(/img/icono-flecha-derecha-blanco.svg) !important;
}
.boton-negro:hover::after, .boton-negro:focus::after {
    background-image: url(/img/icono-flecha-derecha-negro.svg) !important;
}
.boton-flecha{
    width: 100%;
    margin-top: 25px;
    font-size: 1.5rem;
    margin-bottom: 0;
}
.ico{
    background-image: url(/img/icono-lupa.svg);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 34px;
    height: 40px;
    padding: 0;
    position: absolute;
    right: 6px;
    top: 12px;
    width: 40px;
    opacity: 0.3;
}
#modal--buscar-input{
    padding: 10px 10px;
    padding-right: 48px;
    font-size: 32px;
    border: 1px solid #333;
    background-color: #fff;
}
select{
    width: 100%;
    font-size: 24px;
    padding: 17px 10px;
    border: 0;
    line-height: normal !important;
    background-color: #fff !important;
    border: 1px solid !important;
}
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: gray !important;
  font-size: 25px;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: gray !important;
  font-size: 25px;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: gray !important;
  font-size: 25px;
}
select:required:invalid {
  color: gray;
}
/* the modification */
option:first-of-type {
  display: none;
}
</style>
